function domain() {
  let host = window.location.hostname.split('.');
  host.shift();
  return `.${host.join('.')}`;
}

export function removeItem(cookie: string) {
  document.cookie =
    cookie + `=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain()};`;
  return true;
}

export function getItem(name: string, format?: null | string) {
  let regex = new RegExp('(^| )' + name + '=([^;]+)');
  let match = document.cookie.match(regex);
  if (match) {
    const value = atob(match[2]);
    if (format === 'json') {
      return JSON.parse(value || '{}');
    }
    return value;
  }
  return null;
}

export function setItem(name: string, value: any, format?: null | string) {
  let set = value;
  if (format === 'json') {
    set = JSON.stringify(value);
  }
  document.cookie = `${name}=${btoa(set)}; path=/; domain=${domain()};`;
  return true;
}

const cookies = () => {};
export { cookies };
cookies.removeItem = removeItem;
cookies.getItem = getItem;
cookies.setItem = setItem;
